import React, { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Input = ({ id, name, value, onChange, className, type, label, valid, helper, disabled, autoFocus }) => {
    const [focus, setFocus] = useState(false);
    const [filled, setFilled] = useState(!!value);
    const onFocus = () => {
        setFocus(true);
        setFilled(true);
    };
    const onBlur = () => {
        setFocus(false);
        setFilled(!!value);
    };
    useEffect(() => {
        setFilled(!!value);
    }, [value]);
    return (
        <>
            <div className={cx('control', className)}>
                <label
                    htmlFor={id} className={cx('control-label', { 'control-label--focused': focus,
                        'control-label--filled': filled,
                        'control-label--invalid': !valid,
                        'control-label--disabled': disabled, })}
                >
                    {label}

                </label>
                <div
                    className={cx('control-input input', { 'input--focused': focus,
                        'input--filled': filled,
                        'input--invalid': !valid,
                        'input--disabled': disabled })}
                >
                    <input
                        className="input-field"
                        id={id}
                        type={type}
                        name={name}
                        value={value}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onChange={onChange}
                        disabled={disabled}
                        autoFocus={autoFocus}
                    />
                    <fieldset aria-hidden="true" className={cx('input-outline outline', { 'outline--focused': focus, 'outline--filled': filled, 'outline--invalid': !valid, 'outline--disabled': disabled })}>
                        <legend className={cx('outline-legend', { 'outline-legend--focused': focus, 'outline-legend--filled': filled, 'outline-legend--invalid': !valid, 'outline--legend': disabled })}>
                            <span>
                                {label}
                            </span>
                        </legend>
                    </fieldset>
                </div>
                {helper && <p className={cx('control-helper', { 'control-helper--focused': focus, 'control-helper--filled': filled, 'control-helper--invalid': !valid, 'control-helper--disabled': disabled })}>{helper}</p>}
            </div>
        </>
    );
};

Input.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    helper: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    valid: PropTypes.bool,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool
};
Input.defaultProps = {
    id: uuid(),
    name: '',
    label: '',
    type: 'text',
    valid: true,
    helper: null,
    disabled: false,
    autoFocus: false
};
export default Input;
